import { Group, Text, Box, Stack } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { SCHEDULE_CELL_CONFIG } from '../../../../config/statusConfig';

const LEGEND_ITEMS = [
  'scheduled',
  'available',
  'unavailable',
  'awaiting_response',
  'not_requested',
] as const;

export function CoachScheduleLegend() {
  return (
    <Stack gap={8}>
      <Group gap="lg" wrap="wrap">
        {LEGEND_ITEMS.map((state) => {
          const config = SCHEDULE_CELL_CONFIG[state];
          return (
            <Group key={state} gap={6}>
              <Box
                style={{
                  width: 14,
                  height: 14,
                  borderRadius: 2,
                  backgroundColor: state === 'scheduled' ? config.bgColor : config.bgColor,
                  border:
                    config.borderColor
                      ? `1.5px ${config.borderStyle || 'solid'} ${config.borderColor}`
                      : `1px solid ${config.color}`,
                  ...(state === 'scheduled' ? { backgroundColor: config.color } : {}),
                }}
              />
              <Text size="sm" c="dimmed">
                {config.label}
              </Text>
            </Group>
          );
        })}

        {/* Conflict legend item (MED-454) */}
        <Group gap={6}>
          <Box
            style={{
              width: 14,
              height: 14,
              borderRadius: 2,
              backgroundColor: 'rgba(233,162,59,0.08)',
              border: '1.5px dashed #E9A23B',
            }}
          />
          <Group gap={2}>
            <IconAlertTriangle size={14} color="#E9A23B" />
            <Text size="sm" c="dimmed">
              Conflict
            </Text>
          </Group>
        </Group>
      </Group>

    </Stack>
  );
}
